import _defineProperty from '../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import _slicedToArray from '../../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js';
import React__default, { useState } from 'react';
import PropTypes__default from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import PopupMenuItem from './PopupMenuItem.js';
import clsx from 'clsx';
import { Popper, ClickAwayListener, Paper, List } from '@material-ui/core';

var useStyles = makeStyles(function (theme) {
  return {
    root: {
      zIndex: 1300
    },
    listItem: {
      height: theme.spacing(5),
      "&:hover": {
        backgroundColor: "".concat(theme.palette.secondary[50], " !important")
      }
    },
    subListItem: {
      width: theme.spacing(30),
      height: theme.spacing(5),
      "&:hover": {
        backgroundColor: "".concat(theme.palette.secondary[50], " !important")
      }
    },
    active: {
      backgroundColor: "".concat(theme.palette.secondary[50], " !important")
    }
  };
});
var PopupMenu = function PopupMenu(_ref) {
  var anchorEl = _ref.anchorEl,
    onClose = _ref.onClose,
    menuItems = _ref.menuItems,
    submenuCloseOnMouseLeave = _ref.submenuCloseOnMouseLeave,
    subMenuOpenMode = _ref.subMenuOpenMode,
    className = _ref.className;
  var classes = useStyles();
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    active = _useState2[0],
    setActive = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    subMenuAnchorEl = _useState4[0],
    setSubMenuAnchorEl = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    subMenuContent = _useState6[0],
    setSubMenuContent = _useState6[1];
  var menuOpen = Boolean(anchorEl);
  var id = menuOpen ? "menu-popper" : undefined;
  var subMenuOpen = Boolean(subMenuAnchorEl);
  var subMenuId = subMenuOpen ? "submenu-popper" : undefined;
  var handleToggleSubMenu = function handleToggleSubMenu(event, subMenuItems, item) {
    if (event && subMenuItems !== null && subMenuItems !== void 0 && subMenuItems.length && item) {
      setSubMenuContent(subMenuItems);
      setSubMenuAnchorEl(event.currentTarget);
      setActive(item);
    } else {
      setSubMenuContent(null);
      setSubMenuAnchorEl(null);
      setActive();
    }
  };
  var handleSubmenuMouseLeave = function handleSubmenuMouseLeave() {
    if (submenuCloseOnMouseLeave) {
      handleToggleSubMenu();
    }
  };
  var handleCloseMenu = function handleCloseMenu() {
    handleToggleSubMenu();
    onClose();
  };
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Popper, {
    id: id,
    open: menuOpen,
    anchorEl: anchorEl,
    className: clsx(classes.root, className),
    placement: "bottom"
  }, /*#__PURE__*/React__default.createElement(ClickAwayListener, {
    onClickAway: handleCloseMenu
  }, /*#__PURE__*/React__default.createElement(Paper, null, /*#__PURE__*/React__default.createElement(List, {
    disablePadding: true
  }, menuItems.map(function (item, index) {
    var _item$subItems;
    return /*#__PURE__*/React__default.createElement(PopupMenuItem, {
      onMouseEnter: function onMouseEnter(event) {
        if (subMenuOpenMode === "hover") {
          handleToggleSubMenu(event, item === null || item === void 0 ? void 0 : item.subItems, item);
        }
      },
      onClick: function onClick(event) {
        if (subMenuOpenMode === "click") {
          handleToggleSubMenu(event, item === null || item === void 0 ? void 0 : item.subItems, item);
        }
      },
      key: index,
      className: clsx(classes.listItem, _defineProperty({}, classes.active, (active === null || active === void 0 ? void 0 : active.text) === (item === null || item === void 0 ? void 0 : item.text))),
      text: item === null || item === void 0 ? void 0 : item.text,
      icon: item === null || item === void 0 ? void 0 : item.icon,
      href: subMenuOpenMode === "hover" || !(item !== null && item !== void 0 && (_item$subItems = item.subItems) !== null && _item$subItems !== void 0 && _item$subItems.length) ? item === null || item === void 0 ? void 0 : item.href : null
    });
  })), /*#__PURE__*/React__default.createElement(Popper, {
    id: subMenuId,
    open: subMenuOpen,
    anchorEl: subMenuAnchorEl,
    className: classes.root,
    placement: "right-start"
  }, /*#__PURE__*/React__default.createElement(Paper, {
    onMouseLeave: handleSubmenuMouseLeave
  }, /*#__PURE__*/React__default.createElement(List, {
    disablePadding: true
  }, subMenuContent === null || subMenuContent === void 0 ? void 0 : subMenuContent.map(function (item, index) {
    return /*#__PURE__*/React__default.createElement(PopupMenuItem, {
      key: index,
      className: classes.subListItem,
      text: item === null || item === void 0 ? void 0 : item.text,
      icon: item === null || item === void 0 ? void 0 : item.icon,
      href: item === null || item === void 0 ? void 0 : item.href
    });
  }))))))));
};
PopupMenu.propTypes = {
  submenuCloseOnMouseLeave: PropTypes__default.bool,
  subMenuOpenMode: PropTypes__default.oneOf(["hover", "click"]).isRequired,
  anchorEl: PropTypes__default.any,
  onClose: PropTypes__default.func.isRequired,
  menuItems: PropTypes__default.arrayOf(PropTypes__default.shape({
    text: PropTypes__default.string.isRequired,
    icon: PropTypes__default.element,
    href: PropTypes__default.string,
    subItems: PropTypes__default.array
  })).isRequired,
  className: PropTypes__default.any
};

export { PopupMenu as default };
//# sourceMappingURL=PopupMenu.js.map
